import React from 'react';

import DropdownLabel from 'components/lib/DropdownLabel';

interface Props {
  selection: number;
  options: any[];
  onSelect: any;
}

const WidgetFiltersInfoSelect = ({ selection, options, onSelect }: Props) => {
  return (
    <>
      <DropdownLabel selection={selection} options={options} onSelect={onSelect} />
      <span>·</span>
    </>
  );
};

export default WidgetFiltersInfoSelect;
